export default "__VITE_ASSET__137decd3__"